import { isElement } from '../../utils';

import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(Flip, ScrollToPlugin);

let fixedEl = null;

let imagesWrapper = null;
let imagesWrapperRect = null;
let currentImageWrapper = null;
let currentImage = null;
let nextImage = null;
let breakpoint = window.matchMedia('(max-width: 991px)');

let state = null;

function matchesTrigger(el) {
	const selectors = ['[data-events-event-trigger]'];
	return selectors.some((selector) => el.matches(selector));
}

export default {
	name: 'events-event',
	from: {
		custom: ({ current, next, trigger }) => {
			if (breakpoint.matches) {
				return false;
			}
			return isElement(trigger) && matchesTrigger(trigger);
		},
	},
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			document.dispatchEvent(new CustomEvent('disable-scroll'));
			document.dispatchEvent(new CustomEvent('transition-start'));

			gsap.set(current.container, {
				pointerEvents: 'none',
			});

			imagesWrapper = current.container.querySelector('[data-images-wrapper]');
			const id = trigger.closest('[data-event]').getAttribute('data-event');
			currentImageWrapper = current.container.querySelector(`[data-event-image="${id}"]`);
			gsap.set(currentImageWrapper, {
				opacity: 1,
			});

			currentImage = current.container.querySelector(`[data-event-image="${id}"]`).querySelector('.img');
			Flip.fit(currentImage, currentImageWrapper);

			const aside = current.container.querySelector('[data-events-aside]');
			const content = current.container.querySelector('[data-events-content]');

			const tl = gsap.timeline({
				paused: true,
				onComplete: () => {
					resolve();
				},
			});

			tl.to(
				[aside, content],
				{
					autoAlpha: 0,
					duration: 0.2,
					ease: 'none',
				},
				0
			);

			const mainScrollHeight = current.container.querySelector('main').scrollHeight;
			if (window.scrollY + window.innerHeight > mainScrollHeight) {
				tl.to(
					window,
					{
						duration: 0.2,
						ease: 'sine.inOut',
						scrollTo: {
							y: mainScrollHeight - window.innerHeight,
						},
					},
					0
				);
			}

			tl.play();
		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.set(current.container, {
				autoAlpha: 0,
			});

			next.container.querySelector('[data-event]').classList.add('before-animation');

			fixedEl = document.createElement('div');
			imagesWrapperRect = imagesWrapper.getBoundingClientRect();
			gsap.set(fixedEl, {
				position: 'fixed',
				zIndex: 30,
				width: imagesWrapperRect.width,
				height: imagesWrapperRect.height,
				left: imagesWrapperRect.left,
				top: imagesWrapperRect.top,
				overflow: 'hidden',
			});
			document.body.appendChild(fixedEl);
			fixedEl.appendChild(currentImage);

			gsap.set(current.container, {
				position: 'fixed',
			});

			gsap.set(next.container, {
				opacity: 0,
			});

			resolve();
		});
	},

	beforeEnter({ current, next, trigger }) {
		return new Promise((resolve) => {
			window.scrollTo(0, 0);

			state = Flip.getState(currentImage);

			gsap.set(next.container, {
				clearProps: 'opacity',
			});

			// Next Image
			const nextImageWrapper = next.container.querySelector('[data-event-image]');
			nextImage = nextImageWrapper.querySelector('.img');
			nextImage.replaceWith(currentImage);
			fixedEl.remove();

			const color_m = next.container.dataset.colorM;
			const background_m = next.container.dataset.backgroundM;
			const color_d = next.container.dataset.colorD;
			const background_d = next.container.dataset.backgroundD;
			gsap.to(document.documentElement, {
				'--color-m': color_m,
				'--background-m': background_m,
				'--color-d': color_d,
				'--background-d': background_d,
				duration: 1.4,
				ease: 'none',
			});

			Flip.from(state, {
				simple: true,
				absolute: true,
				scale: true,
				duration: 1.4,
				ease: 'expo.inOut',
				onComplete: () => {
					gsap.set(currentImage, {
						clearProps: 'all',
					});

					resolve();
				},
			});
		});
	},
	after({ current, next, trigger }) {
		return new Promise((resolve) => {
			document.dispatchEvent(new CustomEvent('enable-scroll'));
			document.dispatchEvent(new CustomEvent('transition-end'));

			const event = next.container.querySelector('[data-event]');
			const aside = next.container.querySelector('[data-event-aside]');
			const eventInfo = next.container.querySelector('[data-event-info]');

			gsap.set([aside, eventInfo], {
				opacity: 0,
				onComplete: () => {
					event.classList.remove('before-animation');
				},
			});

			gsap.to([aside, eventInfo], {
				opacity: 1,
				duration: 0.8,
				ease: 'none',
				onComplete: () => {
					resolve();
				},
			});
		});
	},
};
